/* eslint-disable react/forbid-dom-props */
/* eslint-disable max-len */
import {
    SearchIconComponent as SourceSearchIcon,
} from 'SourceComponent/SearchIcon/SearchIcon.component';

/** @namespace Theme/Component/SearchIcon/Component */
export class SearchIconComponent extends SourceSearchIcon {
    render() {
        return (
            <svg
              block="SearchIcon"
              xmlns="http://www.w3.org/2000/svg"
              width="17"
              height="17"
              viewBox="0 0 27.902 28.058"
            >
                <g
                  transform="translate(-155.617 -267)"
                >
                    <rect
                      className="a"
                      width="2.919"
                      height="2.919"
                      fill="#00c7fe"
                      transform="translate(179.391 292.993) rotate(-45)"
                    />
                    <path
                      className="b"
                      fill="#0068b5"
                      d="M29.88,27.208,25.9,23.229a11.528,11.528,0,1,0-2.69,2.691L27.19,30ZM11.047,22.037a7.685,7.685,0,1,1,5.5,2.314A7.692,7.692,0,0,1,11.047,22.037Z"
                      transform="translate(150.631 262.005)"
                    />
                </g>
            </svg>
        );
    }
}

export default SearchIconComponent;
